export default "__VITE_ASSET__9f5c6733__"